import SelectCustomizable from 'core/modules/atoms/SelectCustomizable';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { withTranslation } from 'react-i18next';

const SpecialNeedsSelector = React.forwardRef(function SpecialNeedsSelectorComponent(
  { t, value = [], onChange, required = false, showLabel = true, disabled = false, name = 'special-needs-selector' },
  ref
) {
  // Define special needs options
  const options = useMemo(
    () => [
      { value: 'high_abilities', label: t('chatbot:High abilities') },
      { value: 'tea', label: t('chatbot:TEA') },
      { value: 'tdah', label: t('chatbot:TDAH') },
      { value: 'dyslexia', label: t('chatbot:Dyslexia') },
      { value: 'dysgrafia', label: t('chatbot:Dysgrafia') },
      { value: 'dyscalculia', label: t('chatbot:Dyscalculia') },
      { value: 'language_disorders', label: t('chatbot:Language disorders') },
    ],
    [t]
  );

  function handleChange(selectedOptions) {
    // selectedOptions will be an array of option objects or null
    if (!selectedOptions) {
      onChange([]);
      return;
    }

    // Extract just the values for the onChange callback
    const values = selectedOptions.map((opt) => opt.value);
    onChange(values);
  }

  // Convert value array to option objects for SelectCustomizable
  const selectedValue = useMemo(() => {
    if (!value || value.length === 0) return [];
    return options.filter((opt) => value.includes(opt.value));
  }, [value, options]);

  return (
    <div className="special-needs-selector" ref={ref}>
      <SelectCustomizable
        options={options}
        name={name}
        label={showLabel ? t('chatbot:Special needs') : null}
        placeholder={t('chatbot:Select special needs')}
        onChange={handleChange}
        value={selectedValue}
        isMulti={true}
        isSearchable={false}
        required={required}
        isDisabled={disabled}
        closeMenuOnSelect={false}
      />
    </div>
  );
});

SpecialNeedsSelector.propTypes = {
  t: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  showLabel: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
};

export default withTranslation(['chatbot'])(SpecialNeedsSelector);
